import { z } from "zod";
import { MAX_MENTIONS_PER_CONTENT } from "../../utils/mentions.js";
import { overlayTextsNullableSchema } from "../overlay-text.js";

export const updatePostSchema = z
	.object({
		caption: z.string().max(200).optional(),
		overlay_texts: overlayTextsNullableSchema,
		mention_ids: z.array(z.uuid()).max(MAX_MENTIONS_PER_CONTENT).optional(),
	})
	.strict();

export type UpdatePostPayload = z.infer<typeof updatePostSchema>;
